import firebase from 'firebase/app'

export class Time {
  private timeCollection: firebase.firestore.CollectionReference
  private gap = 0

  constructor () {
    this.timeCollection = firebase.firestore().collection(`time`)
  }

  public async getGap() {
    if (this.gap === 0) {
      const serverDate = await this.getServerTime()
      this.gap = serverDate.getTime() - Date.now()
    }
    
    return this.gap
  }

  private async getServerTime () {
    const docRef = await this.timeCollection.add({
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    }).catch((error) => {
      throw error
    });

    const snapshot = await docRef.get()
    const data = snapshot.data()

    if (data) {
      docRef.delete()
      return data.timestamp.toDate()
    }
  }
}